import { render } from "./side-nav-outer-toolbar.vue?vue&type=template&id=4086aae8"
import script from "./side-nav-outer-toolbar.vue?vue&type=script&lang=js"
export * from "./side-nav-outer-toolbar.vue?vue&type=script&lang=js"

import "./side-nav-outer-toolbar.vue?vue&type=style&index=0&id=4086aae8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/side-nav-outer-toolbar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4086aae8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4086aae8', __exports__)) {
    api.reload('4086aae8', __exports__)
  }
  
  module.hot.accept("./side-nav-outer-toolbar.vue?vue&type=template&id=4086aae8", () => {
    api.rerender('4086aae8', render)
  })

}


export default __exports__